/* ----------------------------- assets ----------------------------- */
export const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/a421fc4c-04c6-4c3c-9709-60b8a409d32c/images/689d95e712dcba13d32a6e0c123c1fa1896e756da68f7c9865db763dc6da2965.png";
export const HERO_LOGO = "/fbp-logo.png";
export const BPT_INUSE_IMG =
  "https://customer-assets.emergentagent.com/job_a421fc4c-04c6-4c3c-9709-60b8a409d32c/artifacts/wm02pln0_thebackpaintransformer.png";
export const BPT_POSTURE_IMG =
  "https://customer-assets.emergentagent.com/job_a421fc4c-04c6-4c3c-9709-60b8a409d32c/artifacts/lhsoaikh_backpaintransformermanpointers.png";
export const APP_IMG =
  "https://customer-assets.emergentagent.com/job_a421fc4c-04c6-4c3c-9709-60b8a409d32c/artifacts/vtzpk2iz_fbpwebapp.jpg";
export const BRAIN_NERVES_IMG =
  "https://static.prod-images.emergentagent.com/jobs/a421fc4c-04c6-4c3c-9709-60b8a409d32c/images/e8b76774f8f13d926e916d5451192af88761d2a39e89a763424871475de3da84.png";
export const LEGS_COMPARE_IMG =
  "https://static.prod-images.emergentagent.com/jobs/a421fc4c-04c6-4c3c-9709-60b8a409d32c/images/ba74225eff1c099425b4ad342cf3343ad56d0f797409af3c4b299e384ec7df7d.jpeg";
export const FREEDOM_KIT_IMG =
  "https://customer-assets.emergentagent.com/job_a421fc4c-04c6-4c3c-9709-60b8a409d32c/artifacts/60eu2xxt_freedomkit.png";

/* Paste your YouTube/Vimeo embed URL or a direct .mp4 link here to go live. */
export const EXPLAINER_VIDEO_URL = "https://www.youtube.com/embed/abz7NwdSciE";
export const VIDEO_POSTER_IMG =
  "https://customer-assets.emergentagent.com/job_a421fc4c-04c6-4c3c-9709-60b8a409d32c/artifacts/vrp1x6ye_videoland3.jpg";

/* Temporarily hide the PayPal checkout card while finalizing the checkout method.
   Flip to true to bring it back. */
export const SHOW_CHECKOUT = true;

/* ----------------------------- data ----------------------------- */
export const DEVICE_SLIDES = [
  { src: BPT_INUSE_IMG, alt: "Person wearing the Back Pain Transformer support" },
  { src: BPT_POSTURE_IMG, alt: "Back Pain Transformer posture benefits — head balanced, shoulders retracted, spine erect" },
];

export const BPT_BENEFITS = [
  { t: "Perfect alignment, instantly", d: "Lifts and holds your body in proper alignment the moment you put it on." },
  { t: "Unleashes your core power", d: "Reactivates the deep stabilizers that protect and support your spine." },
  { t: "Room to breathe & function", d: "Expands space for your vital organs to operate at their optimum." },
  { t: "Relief where it matters most", d: "Lifts downward pressure off your glutes — easing strain on your lower back and sciatic nerve." },
  { t: "A new relationship with gravity", d: "Instantly changes how gravity acts on your body, returning physical confidence to every movement." },
];

export const APP_FEATURES = [
  { practice: "Practice 1", name: "Future Self Visualization", t: "Become the Person Beyond the Pain", d: "Create a vivid vision of who you'll become without back pain—and begin thinking, moving, and living as your future self today.", c: "#22D3EE" },
  { practice: "Practice 2", name: "Survey", t: "Discover Your Pain Patterns", d: "Identify the hidden physical, mental, and emotional factors contributing to your pain.", c: "#38BDF8" },
  { practice: "Practice 3", name: "Body Pain Scan", t: "See Your Progress", d: "Track your pain visually as your body becomes stronger, freer, and more resilient.", c: "#34C759" },
  { practice: "Practice 4", name: "Video Lesson", t: "Change How You Think About Pain", d: "Replace outdated beliefs with evidence-based strategies that help retrain your brain and body.", c: "#F59E0B" },
  { practice: "Practice 5", name: "Guided Journal", t: "Let Go of What's Holding You Back", d: "Release stored emotional tension and develop a healthier relationship with pain.", c: "#A855F7" },
  { practice: "Practice 6", name: "Daily Activities", t: "Heal While Living Your Life", d: "Transform ordinary daily tasks into opportunities to restore alignment, rebuild strength, and move with confidence.", c: "#22D3EE" },
];

export const WEEK_CHIPS = [
  ["Week 1", "Reset"],
  ["Week 2", "Rebuild"],
  ["Week 3", "Restore"],
  ["Week 4", "Optimize"],
];

export const TESTIMONIALS = [
  { n: "Marina P.", q: "I used to dread waking up in the morning having to face exhausting pain. Now I bounce out of bed, bend, jump and exercise with total freedom from chronic pain.", img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=120&q=80" },
  { n: "Sarah L.", q: "I can pick up my kids again without bracing for the pain.", img: "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&w=120&q=80" },
  { n: "James R.", q: "Four weeks in and the pain is essentially gone.", img: "https://images.unsplash.com/photo-1559097280-ce4b032b67a6?auto=format&fit=crop&w=120&q=80" },
];

export const PAIN_REASONS = [
  { t: "Pills only mask the pain", d: "And once they wear off, the ache returns — often worse than before." },
  { t: "Surgery is risky and final", d: "Painful recovery, costly bills, and zero guarantee it actually works." },
  { t: "Chiropractor visits don't last", d: "You feel great for a day or two, then you're booking the next session." },
  { t: "Stretching alone isn't enough", d: "Without addressing the real root, the pain quietly comes creeping back." },
  { t: "Working out can backfire", d: "Without fixing the root cause, exercise can overload protective muscles and make pain flare up." },
];
